<template>
  <div class="wrapper-layout">
    <Header @close="closeSessionTransaction" />
    <Menu :user-auth="userAuth" />
    <div class="router-view-container">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import Header from "./components/Header.vue";
import Menu from "./components/Menu.vue";
import { defineComponent, inject, onMounted } from "vue";
import { layoutUse } from "@/ux/layout/use/layoutUse";
import { spinnerProcessKey } from "@/main";
import { manageRefreshProcess } from "@/business/shared/session/application/manageRefreshProcess";
import { isRefreshingProcess } from "@/business/shared/session/application/isRefreshingProcess";

export default defineComponent({
  name: "LoginView",
  components: {
    Header,
    Menu,
  },
  setup() {
    const spinnerProcess = inject(spinnerProcessKey)!;
    const { offSpinnerState, onSpinnerState } = spinnerProcess;

    const {
      userAuth,
      closeSessionOperation,
      saveSessionTransaction,
    } = layoutUse();

    onMounted(() => {
      window.addEventListener("beforeunload", handleBeforeUnload);
      manageRefreshProcess.freeProcess();
    });

    const handleBeforeUnload = async (
      event: BeforeUnloadEvent
    ) => {
      if (!isRefreshingProcess.execute()) {
        manageRefreshProcess.busyProcess();
        await saveSessionTransaction();
        event.returnValue = "";
        manageRefreshProcess.freeProcess();
      } else {
        event.preventDefault();
      }
    };

    async function closeSessionTransaction(): Promise<void> {
      try {
        await onSpinnerState();
        await closeSessionOperation();
        await offSpinnerState();
      } catch (exception) {
        await offSpinnerState();
        throw exception;
      }
    }

    return {
      userAuth,
      closeSessionTransaction,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/layout/styles/layoutStyle";
</style>
